Alpine.data('mpLetterTips', () => {
	const originalCopyText = 'Copy all';
	const originalIconCopyText = '';

	return {
		contentCopy: '',
		copyText: originalCopyText,
		copyIconText1: originalIconCopyText,
		copyIconText2: originalIconCopyText,
		copyIconText3: originalIconCopyText,
		copyIconText4: originalIconCopyText,

		init() {},
		copy(data) {
			const textarea = document.createElement('textarea');
			textarea.innerHTML = data;
			document.body.appendChild(textarea);

			try {
				textarea.select();
				document.execCommand('copy');
				return true;
			} catch (e) {
				return false;
			} finally {
				document.body.removeChild(textarea);
			}
		},
		copyAll() {
			const messageToCopy = [
				this.$refs['suggestion-1'].textContent || '',
				this.$refs['suggestion-2']?.textContent || '',
				this.$refs['suggestion-3']?.textContent || '',
				this.$refs['suggestion-4']?.textContent || '',
			].join('\n\n');

			if (this.copy(messageToCopy)) {
				this.copyText = 'Copied';

				setTimeout(() => {
					this.copyText = originalCopyText;
				}, 3000);

				this.$dispatch('copy-all', {
					text: messageToCopy,
				});
			} else {
				this.copyText =
					'Could not copy text. Please manually copy it using the preview above.';
			}
		},
		copyToClipboard(content) {
			const messageToCopy = this.$refs[content].textContent;

			if (this.copy(messageToCopy)) {
				const updateCopyIconText = (property) => {
					this[property] = 'Copied';
					setTimeout(() => {
						this[property] = originalIconCopyText;
					}, 1500);
				};

				switch (content) {
					case 'suggestion-1':
						updateCopyIconText('copyIconText1');
						break;
					case 'suggestion-2':
						updateCopyIconText('copyIconText2');
						break;
					case 'suggestion-3':
						updateCopyIconText('copyIconText3');
						break;
					case 'suggestion-4':
						updateCopyIconText('copyIconText4');
						break;
					default:
						break;
				}
			}
		},
	};
});
